import { useState } from 'react';
import { toast } from 'react-toastify';

import { DeadLetterQueue, eventingApi } from '../../../../../services/eventingApi';

export const useRedrive = (onDone: () => void) => {
  const [confirming, setConfirming] = useState<DeadLetterQueue | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const redrive = async (queue: DeadLetterQueue) => {
    setSubmitting(true);
    try {
      const result = await eventingApi.createRedrive(queue.consumer);
      toast.success(`Redrive iniciado: ${result.data.deadLetterQueueName} → ${result.data.queueName}`);
      setConfirming(null);
      onDone();
    } catch (error) {
      toast.error((error as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  return { confirming, setConfirming, submitting, redrive };
};
